export const MOBILE = 'M';
export const EMAIL = 'E';
export const HOME_PHONE = 'H';
export const BUSINESS = 'B';
export const LOCAL = 'L';
